<template>
  <v-list-item two-line>
    <v-list-item-action>
      <v-checkbox
          v-model="layerAction"
          :disabled="layerInfo.disabled"
      ></v-checkbox>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-text="layerInfo.name"/>
      <v-list-item-subtitle v-text="layerInfo.subname"/>
    </v-list-item-content>
    <v-list-item-action v-if="layerInfo.infoText">
      <v-dialog
          v-model="dialog"
          scrollable
          width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on">
            <v-icon color="grey lighten-1">mdi-information</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary white--text" >
            {{layerInfo.name}}
          </v-card-title>
          <v-card-text class="pt-3" style="max-height: 500px" v-html="layerInfo.infoText">
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="dialog = false"
            >
              ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import {mapState, mapActions} from "vuex"

export default {
  name: "layerEntry",
  props: ["layerId"],
  data: () => ({
    dialog: false
  }),
  computed: {
    layerAction: {
      get() {
        return this.layerInfo.active
      },
      set() {
        this.toggle_layer(this.layerId)
      }
    },
    ...mapState("map", ["layerInfos"]),
    layerInfo() {
      return this.layerInfos[this.layerId]
    }
  },
  methods: {
    ...mapActions("map", ["toggle_layer"])
  }
}
</script>

<style scoped>

</style>